export default {
    filterNames: {
        employment_types: 'Employment type',
        education_level: 'Degree',
        job_category: 'Fields',
        address: 'Locations',
        sector: 'Sectors',
        exclude_school_id: 'Exclude',
    },

    excludeSchoolIds: {
        '-1': 'Shared posts',
        unknownSchoolId: 'EFMD School Partner',
    },

    educationLevels: {
        BACHELORS_OR_EQUIVALENT: 'Bachelors',
        MASTERS_OR_EQUIVALENT: 'Masters',
        DOCTORAL_OR_EQUIVALENT: 'PHD',
        MBA_OR_EQUIVALENT: 'MBA',
        DBA_OR_EQUIVALENT: 'DBA',
    },
    employmentTypes: {
        FULL_TIME: 'Full time',
        INTERN: 'Internship',
        TEMPORARY: 'Part time',
        PART_TIME: 'Part time',
    },
    startDate: 'Start',
    educationFields: {
        ACCOUNTING_AND_FINANCE: 'Accounting and finance',
        ADMINISTRATIVE_AND_OFFICE: 'Administrative and office',
        ADVERTISING_AND_MARKETING: 'Advertising and marketing',
        ART_FASHION_AND_DESIGN: 'Art fashion and design',
        BUSINESS_OPERATIONS: 'Business operations',
        COMPUTER_AND_IT: 'Computer and IT',
        CUSTOMER_SERVICE: 'Customer service',
        EDUCATION: 'Education',
        HEALTHCARE: 'Healthcare',
        HUMAN_RESOURCES: 'Human resources',
        INSTALLATION_MAINTENANCE_AND_REPAIR:
            'Installation maintenance and repair',
        LEGAL: 'Legal',
        MANAGEMENT: 'Management',
        MANUFACTURING_AND_WAREHOUSE: 'Manufacturing and warehouse',
        MEDIA_COMMUNICATIONS_AND_WRITING: 'Media communications and writing',
        OIL_GAS_AND_MINING: 'Energy',
        PROTECTIVE_SERVICES: 'Protective services',
        REAL_ESTATE: 'Real estate',
        SALES_AND_RETAIL: 'Sales and retail',
        SCIENCE_AND_ENGINEERING: 'Science and engineering',
        SOCIAL_SERVICES_AND_NON_PROFIT: 'Social services and non profit',
        TRANSPORTATION_AND_LOGISTICS: 'Transportation and logistics',
    },
    sectors: {
        Consulting: 'Consulting',
        'Consumer Goods': 'Consumer Goods',
        'Financial Services / Banking': 'Financial Services / Banking',
        'Goverment / Public Administration / Non Profit':
            'Goverment / Public Administration / Non Profit',
        'International Trade & Development':
            'International Trade & Development',
        Manufacturing: 'Manufacturing',
        'Media / Entertainment': 'Media / Entertainment',
        'Petroleum / Energy': 'Petroleum / Energy',
        'Pharma / Healthcare / Biotech': 'Pharma / Healthcare / Biotech',
        'Real Estate / Construction / Infrastructure':
            'Real Estate / Construction / Infrastructure',
        'Technology (IT) / Telecom': 'Technology (IT) / Telecom',
        'Transportations & Logistics': 'Transportations & Logistics',
        Other: 'Other',
    },
    countries: {
        Norway: 'Norway',
        Spain: 'Spain',
        China: 'China',
        Netherlands: 'Netherlands',
        Morocco: 'Morocco',
        Argentina: 'Argentina',
        Belgium: 'Belgium',
        France: 'France',
        Switzerland: 'Switzerland',
        'United Kingdom': 'United Kingdom',
        Germany: 'Germany',
        Luxembourg: 'Luxembourg',
        'United Arab Emirates': 'United Arab Emirates',
        Ukraina: 'Ukraine',
        Italy: 'Italy',
        Brazil: 'Brazil',
        USA: 'USA',
        Russia: 'Russia',
        Swaziland: 'Swaziland',
        India: 'India',
        Australia: 'Australia',
        Afghanistan: 'Afghanistan',
        Austria: 'Austria',
        Philippines: 'Philippines',
        Poland: 'Poland',
        Singapore: 'Singapore',
        Sweden: 'Sweden',
        'China (Hong Kong SAR)': 'Hong Kong',
        Denmark: 'Denmark',
        Portugal: 'Portugal',
        Indonesia: 'Indonesia',
        Malaysia: 'Malaysia',
        'Korea, South': 'South Korea',
        Mexico: 'Mexico',
        Qatar: 'Qatar',
        'Costa Rica': 'Costa Rica',
        Finland: 'Finland',
        Canada: 'Canada',
        Lithuania: 'Lithuania',
        Kuwait: 'Kuwait',
        Hungary: 'Hungary',
        Ireland: 'Ireland',
        Thailand: 'Thailand',
        'Taiwan (Province of China)': 'Taiwan',
        Kazakhstan: 'Kazakhstan',
        'New Zealand': 'New Zealand',
        Czechia: 'Czechia',
        Egypt: 'Egypt',
        Turkey: 'Turkey',
        'South Africa': 'South Africa',
        Slovakia: 'Slovakia',
        Paraguay: 'Paraguay',
        Kenya: 'Kenya',
        Zambia: 'Zambia',
        Botswana: 'Botswana',
        Etiopia: 'Ethiopia',
        Tanzania: 'Tanzania',
        Japan: 'Japan',
        Romania: 'Romania',
        Greece: 'Greece',
        Senegal: 'Senegal',
        Israel: 'Israel',
        Mauritius: 'Mauritius',
        'Saudi Arabia': 'Saudi Arabia',
        'Europe & Sub-Saharan Africa': 'Europe & Sub-Saharan Africa',
        Pakistan: 'Pakistan',
        Armenia: 'Armenia',
        Bulgaria: 'Bulgaria',
        Bangladesh: 'Bangladesh',
        Jersey: 'Jersey',
        Estonia: 'Estonia',
        Lebanon: 'Lebanon',
        Latvia: 'Latvia',
        Colombia: 'Colombia',
        Algeria: 'Algeria',
        Jordan: 'Jordan',
        Serbia: 'Serbia',
        Myanmar: 'Myanmar',
        Vietnam: 'Vietnam',
        "Côte d'Ivore (Ivory Coast)": 'Ivory Coast',
        'Puerto Rico': 'Puerto Rico',
        Namibia: 'Namibia',
        Oman: 'Oman',
        Iraq: 'Iraq',
        Chile: 'Chile',
        Croatia: 'Croatia',
        Nigeria: 'Nigeria',
        Slovenia: 'Slovenia',
        Iceland: 'Iceland',
        Syria: 'Syria',
        Vanuatu: 'Vanuatu',
        Mongolia: 'Mongolia',
        Peru: 'Peru',
        Angola: 'Angola',
        Belarus: 'Belarus',
        Tonga: 'Tonga',
        Azerbaijan: 'Azerbaijan',
        Bahamas: 'Bahamas',
        'Papua-Ny Guinea': 'Papua New Guinea',
        Uzbekistan: 'Uzbekistan',
        Fiji: 'Fiji',
        Congo: 'Congo',
        Sudan: 'Sudan',
        Ghana: 'Ghana',
        Ecuador: 'Ecuador',
        Cambodia: 'Cambodia',
        'The Seychell Islands': 'Seychelles',
        'Sri Lanka': 'Sri Lanka',
        Bahrain: 'Bahrain',
        Laos: 'Laos',
        Guernsey: 'Guernsey',
        Cyprus: 'Cyprus',
    },
};
